import { getEnvVar } from '../utilities/getEnvs.js';
import { shouldLogError, loopNestedObj } from './logUtils.js';
import { sendLog } from './sentryLog.js';

var infoTypes = ['mypagesstartpromocard']; // adobe content not created by countries is not an error

var gqlSentryLog = function gqlSentryLog(error) {
  if (error.graphQLErrors) {
    var _operation$variables;
    var operation = error.operation;
    if (infoTypes.includes(operation === null || operation === void 0 ? void 0 : (_operation$variables = operation.variables) === null || _operation$variables === void 0 ? void 0 : _operation$variables.infoType)) {
      return;
    }
    error.graphQLErrors.forEach(function (err) {
      var _shouldLogError = shouldLogError(err),
        log = _shouldLogError.log,
        errorCode = _shouldLogError.errorCode,
        errorGroup = _shouldLogError.errorGroup,
        errorMessage = _shouldLogError.errorMessage,
        status = _shouldLogError.status,
        logTraceId = _shouldLogError.logTraceId;
      if (log) {
        try {
          var redacted = loopNestedObj(operation);
          sendLog(errorCode || "GQL ".concat(getEnvVar('NAME'), " ").concat(operation === null || operation === void 0 ? void 0 : operation.operationName), {
            errorCode: errorCode,
            errorGroup: errorGroup,
            errorMessage: errorMessage,
            operationName: operation === null || operation === void 0 ? void 0 : operation.operationName,
            operation: redacted,
            logTraceId: logTraceId,
            status: status,
            rawError: err
          });
        } catch (_unused) {
          // Should not fail, but just to be safe
        }
      }
    });
  }
};

export { gqlSentryLog };
